import { FC, useRef } from "react";
import { Link, LinkProps } from "react-router-dom";

import SelectedMenuSessionVariable from "@app/layout/menus/constants";
import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import { TooltipWrapper } from "@app/shared";
import { useIsOverflow } from "@app/shared/qes-standards/utility/useIsOverflow";

/** Defines the props used in rendering an SPA link. */
interface MegaMenuLinkProps extends LinkProps {
  faIcon: string;
  linkText: string;
  menuItem: MenuItemEnum;
}

/** Defines a link (SPA) in the mega menu. */
const MegaMenuLink: FC<React.PropsWithChildren<MegaMenuLinkProps>> = (props: MegaMenuLinkProps) => {
  const { children, faIcon, linkText, menuItem, ...linkProps } = props;
  const linkRef = useRef(null);
  const showTooltip = useIsOverflow(linkRef);

  const selectedMenuItemSessionValue = sessionStorage.getItem(SelectedMenuSessionVariable);
  const selectedMenuItem = selectedMenuItemSessionValue ? selectedMenuItemSessionValue as MenuItemEnum : MenuItemEnum.Unknown;
  const isSelected = selectedMenuItem === menuItem;

  const link = <Link ref={linkRef} className={`menu-link${isSelected ? " selected-menu-item" : ""}`} {...linkProps} id={`menu__menu-link--${props.menuItem}`}>
    <i className={`menu-icon fa fa-${faIcon}${isSelected ? " selected-menu-item" : ""}`} />
    {linkText}
    {children}
  </Link>;

  return (
    <li className="menu-item">
      <TooltipWrapper text={showTooltip ? linkText : ""} triggerWidth="100%" position="right">
        {link}
      </TooltipWrapper>
    </li>
  );
};

export default MegaMenuLink;
